// modules/estrategias/habitante_calle/offline/habitanteCalleOffline.js
import { crearCrudOffline } from "../../../inicio/offline/crudOfflineFactory";
import { crearPersonaAPI, actualizarPersonaAPI, deletePersona } from "../api/HabitanteCalleAPI";

const crud = crearCrudOffline({
  tablaPendientes: "habitante_calle_pendientes",
  apiCrear: crearPersonaAPI,
  apiActualizar: actualizarPersonaAPI,
  apiEliminar: deletePersona,
});

export const guardarOfflineHabitanteCalle = (payload, personaId) => crud.guardarOffline(payload, personaId);
export const eliminarOfflineHabitanteCalle = (personaId) => crud.eliminarOffline(personaId);
export const contarHabitanteCallePendientes = () => crud.contarPendientes();
export const sincronizarHabitanteCallePendientes = () => crud.sincronizarPendientes();
